// extracted by mini-css-extract-plugin
export default {"settingsModal":"NewSingerModal_settingsModal__FIQOH","faToggle":"NewSingerModal_faToggle__k+w-E"};